import { autoinject } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { ManageRightShipUsersClientService } from "../../../services/modules/righship-qi-manage-users.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { CookieHelper } from "@rightship-tech/common-ui/helpers/cookie-helper";

@autoinject
@transient()
export class TermsAndConditions {
    
    public appEnvironment: string;
    acceptTerms: boolean;

    constructor(private manageRightShipUsersClientService: ManageRightShipUsersClientService,
        private configService: ConfigService) {
            this.appEnvironment = this.configService.config.environment
    }

    accept() {
        return new Promise<void>((resolve, reject) => {
            this.manageRightShipUsersClientService.acceptUserPrivacyPolicyAgreement().then(() => {
                
                //Get the returnUrl from the cookie, decode it and redirect to it
                let referrerUrl = CookieHelper.readCookie("returnUrl") ?? "";
                referrerUrl = decodeURIComponent(referrerUrl); // Decode the URL
                window.location.href = referrerUrl; 

                resolve();
            }).catch(() => {
                reject();
            });
        });        
    }
}